import * as Yup from 'yup'

export const announcementSchema = Yup.object().shape({
  title: Yup.string().trim().required('Title is required.'),
  message: Yup.string().trim().required('Message is required.'),
  target_role: Yup.string()
    .trim()
    .required('Target Role is required.')
    .oneOf(['seller', 'buyer', 'all'], 'Invalid Target Role'),
  status: Yup.string()
    .trim()
    .required('Status is required.')
    .oneOf(['active', 'inactive'], 'Invalid Status'),
})

export const loginSchema = Yup.object().shape({
  username: Yup.string().required('Please enter your email or username'),
  password: Yup.string().required('Please enter your password!'),
})

export const offerTimeFrameSchema = Yup.object().shape({
  timeframe: Yup.number()
    .min(10, 'Timeframe must be greater than 10 minutes')
    .required('Timeframe is required'),
})

export const taxSchema = Yup.object().shape({
  state_code: Yup.string().required('Province is required.'),
  tax_name: Yup.string().trim().required('Tax Name is required.'),
  rate: Yup.number()
    .required('Rate is required.')
    .min(1, 'Rate must be a number between 1 and 100.')
    .max(100, 'Rate must be a number between 1 and 100.'),
  priority: Yup.string().trim().required('Priority is required.'),
})

export const templateSchema = Yup.object().shape({
  from_name: Yup.string().trim().required('From Name is required.'),
  from_email: Yup.string()
    .trim()
    .email('Invalid email address.')
    .required('From Email is required.'),
  type: Yup.string().trim().required('Type is required.'),
  html: Yup.string().trim().required('HTML content is required.'),
  subject: Yup.string().trim().required('Subject is required.'),
})

export const termsSchema = Yup.object().shape({
  version: Yup.string().trim().required('Version is required.'),
  content: Yup.string().trim().required('Content is required.'),
  isActive: Yup.boolean().required('Status is required.'),
})

export const vehicleDetailsSchema = Yup.object().shape({
  odometer: Yup.string().required('Please enter odometer'),
  mileage_unit: Yup.string().required('Please select mileage unit '),
  interior_color: Yup.string().required('Please select interior color '),
  exterior_color: Yup.string().required('Please select exterior color '),
  has_accident: Yup.string(),
})

export const vehicleImagesSchema = Yup.object().shape({
  exterior_main: Yup.string().required('Exterior image is required'),
  interior_driver: Yup.string().required('Interior image is required '),
})

export const buyerFinancialDetailsSchema = Yup.object().shape({
  bank_name: Yup.string().required('Bank name is required'),
  account_number: Yup.string().required('Account number is required'),
  institution_number: Yup.string().required('Institution number is required'),
  transit_number: Yup.string().required('Transit number is required'),
})

export const sellerFinancialDetailsSchema = Yup.object().shape({
  seller_bank_name: Yup.string().required('Bank name is required'),
  seller_account_number: Yup.string().required('Account number is required'),
  seller_account_holder_name: Yup.string().required(
    'Account holder name is required',
  ),
  seller_routing_number: Yup.string().required('Routing number is required'),
})

export const sellerValidationSchema = Yup.object().shape({
  name: Yup.string().required('Dealership name is required'),
  phone: Yup.string()
    .required('Phone number is required')
    .matches(
      /^(\d{10}|\(\d{3}\) \d{3}-\d{4})$/,
      'Phone number must be in the format (xxx) xxx-xxxx',
    ),
  contact_person: Yup.string().required('Contact person is required'),
  email: Yup.string().email('Invalid email address'),
  website: Yup.string().matches(
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    'Enter a valid URL',
  ),
  address: Yup.array().of(
    Yup.object().shape({
      street: Yup.string().required('Street is required'),
      city: Yup.string().required('City is required'),
      province: Yup.string().required('Province is required'),
      postcode: Yup.string().required('Postcode is required'),
    }),
  ),
})

export const buyerValidationSchema = Yup.object().shape({
  name: Yup.string().required('Dealer name is required'),
  phone: Yup.string()
    .required('Phone number is required')
    .matches(
      /^(\d{10}|\(\d{3}\) \d{3}-\d{4})$/,
      'Phone number must be in the format (xxx) xxx-xxxx',
    ),
  contact_person: Yup.string().required('Contact person is required'),
  intrested_province: Yup.array().min(
    1,
    'Please select at least one province from where you wish to purchase a vehicle.',
  ),
  email: Yup.string().email('Invalid email address'),
  website: Yup.string().matches(
    /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
    'Enter a valid URL',
  ),
})

export const vinDecoderSchema = Yup.object().shape({
  vin_number: Yup.string()
    .matches(/^[a-zA-Z0-9]+$/, 'Only alphanumeric characters are allowed')
    .required('VIN is required.')
    .max(17, 'Must be exactly 17 digits')
    .min(17, 'Must be exactly 17 digits')
    .test('trim', 'Please provide valide vin number', (value) => {
      return value.trim().length === value.length
    }),
})

export const paymentContactSchema = Yup.object().shape({
  first_name: Yup.string().trim().required('First name is required'),
  last_name: Yup.string().trim().required('Last name is required'),
  title: Yup.string().trim().required('Job Title / Role is required'),
  phone: Yup.string().trim().required('Direct phone is required'),
  email: Yup.string()
    .trim()
    .email('Invalid email address')
    .required('Accounting email is required'),
})
